import FootballStatus from '@/model/FootballStatus';
import BasketballStatus from '@/model/BasketballStatus';
import MatchType from '@/model/MatchType';

export class Match {
  public static getAwayScore(data: any) {
    if (data.type_id == MatchType.FOOTBALL) {
      if (
        data.status_id == FootballStatus.NOT_START || 
        data.status_id == FootballStatus.CANCELED ||
        data.status_id == FootballStatus.DETERMINED ||
        data.status_id == FootballStatus.PUT_OFF
      ) {
        return '-';
      }
      return data.away_scores && data.away_scores[0] ? data.away_scores[0] : '0';
    } else if (data.type_id == MatchType.BASKETBALL) {
      if (
        data.status_id == BasketballStatus.NOT_START ||
        data.status_id == BasketballStatus.PUT_OFF ||
        data.status_id == BasketballStatus.DETERMINED ||
        data.status_id == BasketballStatus.CANCELED
      ) {
        return '-';
      }
      let sum = 0;
      if (data.away_scores) {
        for (let i = 0; i < data.away_scores.length; i++) {
          const num = Number(data.away_scores[i]);
          if (!isNaN(num)) {
            sum += num;
          }
        }
      }
      return sum;
    }
    return 0;
  }

  public static getHomeScore(data: any) {
    if (data.type_id == MatchType.FOOTBALL) { 
      //是足球

      if (
        data.status_id == FootballStatus.NOT_START ||
        data.status_id == FootballStatus.CANCELED ||
        data.status_id == FootballStatus.DETERMINED ||
        data.status_id == FootballStatus.PUT_OFF
      ) {
        return '-';
      }

      return data.home_scores && data.home_scores[0] ? data.home_scores[0] : '0';
    } else if (data.type_id == MatchType.BASKETBALL) {
      if (
        data.status_id == BasketballStatus.NOT_START ||
        data.status_id == BasketballStatus.PUT_OFF ||
        data.status_id == BasketballStatus.DETERMINED ||
        data.status_id == BasketballStatus.CANCELED
      ) {
        return '-';
      }
      let sum = 0;
      if (data.home_scores) {
        
        for (let i = 0; i < data.home_scores.length; i++) {
          const num = Number(data.home_scores[i]);
          if (!isNaN(num)) {
            sum += num;
          }
        }
      }
      return sum;
    }
    return 0;
  }
  public static getStatus(data) {
    if (data.type_id == MatchType.FOOTBALL) {
      return FootballStatus.getStatus(data.status_id);
    }
    return BasketballStatus.getStatus(data.status_id);
  }
}
